import { IAppState } from './../../../../ngrx.stores/frontend.settings/states';
import { VisitorEventService } from 'src/app/modules/event-calendar/services/visitor.event.service';
import { MediaQueryService } from 'src/app/common/services/media.query/media.query.service';
import { getRouteUrl, routeConfigs } from 'src/app/common/constants/route.config';
import { AccordionComponent } from 'src/app/common/components/accordion/accordion.component';
import { VisitorMenuBarBaseComponent } from './../visitor.menu.bar.base.component';
import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import {
  VisitorEventLayoutService,
  VisitorEventLayoutView,
} from '../../../../services/visitor.event.layout.service';

@Component({
  selector: 'ig-top-bar',
  templateUrl: './visitor.top.bar.component.html',
  styleUrls: ['./visitor.top.bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorTopBarComponent extends VisitorMenuBarBaseComponent {
  private readonly eventCardLayouts = new Set<VisitorEventLayoutView>([
    'default',
    'basic',
    'fancy',
    'square',
    'long',
    'modern-block',
    'vertical',
  ]);

  public get topBarActiveEventLayoutStyle(): VisitorEventLayoutView {
    return this.activeEventLayoutView;
  }

  public get isCardViewActive(): boolean {
    return this.command.isEventCalendar
      ? !this.command.isMapView && this.isCardLayout(this.topBarActiveEventLayoutStyle)
      : !this.command.isMapView;
  }

  public selectTopBarEventLayout(
    event: Event,
    layout: Extract<VisitorEventLayoutView, 'calendar' | 'list'>,
    accordion: AccordionComponent
  ) {
    this.stopTopBarMenuEvent(event);
    if (!this.command.isEventCalendar) return;

    if (!this.command.isMapView && this.topBarActiveEventLayoutStyle === layout) {
      accordion.closeMenu();
      this.close();
      return;
    }

    this.visitorEventLayoutService.setSelectedLayout(layout);

    if (this.command.isMapView) {
      this.command.isMapView = false;
      this._router.navigateByUrl(
        getRouteUrl(routeConfigs.visitor.eventCalendar, {
          hubName: this.hubName,
        }),
        { skipLocationChange: this.noChangeUrlWhenRedirect }
      );
    }

    accordion.closeMenu();
    this.close();
  }

  public selectTopBarCardView(event: Event, accordion: AccordionComponent) {
    this.stopTopBarMenuEvent(event);

    if (this.isCardViewActive) {
      accordion.closeMenu();
      this.close();
      return;
    }

    if (this.command.isEventCalendar) {
      this.visitorEventLayoutService.setSelectedLayout(this.getPreferredCardLayout());
    }

    this.command.isMapView = false;
    this._router.navigateByUrl(
      getRouteUrl(
        this.command.isEventCalendar
          ? routeConfigs.visitor.eventCalendar
          : routeConfigs.visitor.placeCalendar,
        {
          hubName: this.hubName,
        }
      ),
      { skipLocationChange: this.noChangeUrlWhenRedirect }
    );

    accordion.closeMenu();
    this.close();
  }

  public selectTopBarMapView(event: Event, accordion: AccordionComponent) {
    this.stopTopBarMenuEvent(event);
    if (this.command.isMapView) {
      accordion.closeMenu();
      this.close();
      return;
    }

    this.command.isMapView = true;
    const mapRoute = this.command.isEventCalendar
      ? routeConfigs.visitor.eventCalendar.eventMap
      : routeConfigs.visitor.placeCalendar.placeMap;
    this._router.navigateByUrl(
      getRouteUrl(mapRoute, {
        hubName: this.hubName,
      }),
      { skipLocationChange: this.noChangeUrlWhenRedirect }
    );

    accordion.closeMenu();
    this.close();
  }

  private stopTopBarMenuEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  private getPreferredCardLayout(): VisitorEventLayoutView {
    const configuredLayout = this.defaultEventLayoutView;

    return this.isCardLayout(configuredLayout) ? 'default' : 'fancy';
  }

  private isCardLayout(layout: VisitorEventLayoutView | undefined | null): boolean {
    return !!layout && this.eventCardLayouts.has(layout);
  }

  constructor(
    public override activatedRoute: ActivatedRoute,
    public override mediaQueryService: MediaQueryService,
    public override eventService: VisitorEventService,
    public override modalService: ModalService,
    protected override visitorEventLayoutService: VisitorEventLayoutService,
    protected override _router: Router,
    protected override _store: Store<IAppState>
  ) {
    super(
      activatedRoute,
      mediaQueryService,
      eventService,
      modalService,
      visitorEventLayoutService,
      _router,
      _store
    );
  }
}
